var $d8c38c691b006187$exports = {};
$d8c38c691b006187$exports = {
  "removeButtonLabel": "\xCEndep\u0103rta\u0163i",
  "removeDescription": "Ap\u0103sa\u021Bi pe Delete (\u0218tergere) pentru a elimina eticheta."
};
export { $d8c38c691b006187$exports as default };